// extracted by mini-css-extract-plugin
module.exports = {"overlay":"FullScreenLoader_overlay__3s0Av"};